import React, { useState } from 'react';
import '../../css/InsightCard.css';

export const InsightCard = ({ key, count, label, hoverText }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            key={key}
            className={`insight-card-container ${isHovered ? 'hovered' : (count === 0 ? 'zero' : '')}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {isHovered ? (
                <div className="insight-card-hover-text">{hoverText}</div>
            ) : (
                <div className={`insight-card-content`}>
                    <div className="insight-card-count">{count}</div>
                    <div className="insight-card-label">{label}</div>
                    <div className="insight-card-overlay">Coming Soon</div>
                </div>
            )}
        </div>
    );
};
